import { createResource, type RouterContext } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';

import {
	getRoleBasedNotificationDetailEndpoint,
	getRoleBasedNotificationsEndpoint,
} from '../endpoints';

export const roleBasedNotificationsResource = createResource({
	type: 'roleBasedNotificationsResource',
	getKey: () => 'roleBasedNotificationsResource',
	getData: getRoleBasedNotificationsEndpoint,
	isBrowserOnly: true,
	maxAge: 5 * 60 * 1000, // 5 minutes
});

export const notificationDetailResource = createResource({
	type: 'notificationDetailResource',
	getKey: ({ match }: RouterContext) => {
		const settingId = match.params['id'];
		return `notificationDetailResource-id=${settingId}`;
	},
	getData: ({ match }) => {
		const settingId = match.params['id'];
		assert(!!settingId, new AssertionError('notificationDetailResource', 'settingId is required'));
		return getRoleBasedNotificationDetailEndpoint(settingId);
	},
	isBrowserOnly: true,
});

export const resources = [roleBasedNotificationsResource, notificationDetailResource];
